import { UpperCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { SearchState } from '../../store/search.state';
import { SearchFacet } from '../search-facet/search-facet.component';

@Component({
  selector: 'search-facets',
  templateUrl: './search-facets.component.html',
  styleUrl: './search-facets.component.scss',
  imports: [SearchFacet, UpperCasePipe],
  host: {
    '[hidden]': '!this.facets()?.length',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFacets {
  protected readonly activeTab = computed(() => this.state.activeTab());

  protected readonly facets = computed(() =>
    (this.state.currentEntity()?.facets ?? []).filter(
      (facet) =>
        !(
          this.state.activeTab()?.entityType?.toLowerCase() === 'sup' &&
          facet.fieldName === 'qualification_status/id'
        ),
    ),
  );

  protected readonly state = inject(SearchState);
  protected readonly facetsForms = this.state.facetsForms;
}
